
namespace TabAurous.Common {

    @Serenity.Decorators.registerClass()
    export class AcceptReturnDialog extends Serenity.PropertyDialog<any, any>
    {

        public form = new AcceptReturnForm(this.idPrefix);
        public entityId: number;
        public reasonid: number;
        public remark: string;
        public checksuccess: boolean;
        constructor() {
            super();

            this.form = new AcceptReturnForm(this.idPrefix);
        }

        protected getDialogTitle(): string {
            return "Accept Return";
        }
        protected getDialogButtons() {
            return [
                {
                    text: 'Ok',
                    click: () => {
                        if (!this.validateBeforeSave())
                            return;

                        if (this.form.ReasonId.value == null ||
                            Q.isEmptyOrNull(this.form.ReasonId.value)) {
                            Q.notifyError("Please Select Reason");
                            return;
                        }
                        
                        this.reasonid = parseInt(this.form.ReasonId.value);
                        this.checksuccess = true;
                        this.dialogClose();
                        return true;
                    },
                },
                {
                    text: 'Cancel',
                    click: () => this.dialogClose()
                }
            ];
        }
    }
}